import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const CheckmarkIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.6785 5.23145C21.3345 4.86993 20.7767 4.86993 20.4327 5.23145L8.54338 17.7254L3.44034 12.3629C3.09632 12.0014 2.53856 12.0014 2.19454 12.3629C1.85052 12.7244 1.85052 13.3105 2.19454 13.672L7.92048 19.6892C8.26449 20.0507 8.82226 20.0507 9.16628 19.6892L21.6785 6.54061C22.0225 6.17909 22.0225 5.59296 21.6785 5.23145Z"
            fill="currentColor"
         />
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.3163 5.57613C21.1694 5.42171 20.9419 5.42171 20.7949 5.57613L8.90558 18.0701C8.8112 18.1693 8.68028 18.2254 8.54338 18.2254C8.40647 18.2254 8.27555 18.1693 8.18117 18.0701L3.07813 12.7076C2.93118 12.5531 2.70369 12.5531 2.55675 12.7076C2.39645 12.876 2.39645 13.1589 2.55675 13.3274L8.28268 19.3445C8.42963 19.4989 8.65712 19.4989 8.80407 19.3445L21.3163 6.19593C21.4766 6.02748 21.4766 5.74458 21.3163 5.57613ZM20.0705 4.88677C20.6116 4.31816 21.4996 4.31816 22.0407 4.88677C22.5685 5.44135 22.5685 6.33071 22.0407 6.88529L9.52848 20.0339C8.9874 20.6025 8.09936 20.6025 7.55827 20.0339L1.83233 14.0167C1.30459 13.4621 1.30459 12.5728 1.83233 12.0182C2.37342 11.4496 3.26146 11.4496 3.80255 12.0182L8.54338 17.0001L20.0705 4.88677Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default CheckmarkIcon
